import UncontrolledPopover from 'components/SafeUncontrolledPopover';
import { type IntlShape } from 'react-intl';
import RichTextViewer from '../Widgets/Inputs/RichTextViewer';

export const createName = (
  formatMessage,
  name,
  count,
  id,
  size = 'fs-5',
  limit = 50,
  hideCount = false,
  removed_count = undefined
) => {
  // If hideCount is true (header row) and name is empty, show "No factor"
  const displayName =
    hideCount && (!name || name.trim() === '')
      ? formatMessage({
          id: 'app.views.engagement_survey.engagement_survey.no_factor',
          defaultMessage: 'No factor',
        })
      : name;

  const showPopover = limit && displayName?.length > limit;

  const visibleName = displayName;

  return (
    <div>
      <div
        id={id}
        className={'fw-bold text-dark ' + size}
        style={{ whiteSpace: 'normal' }}
      >
        <RichTextViewer model={visibleName} expanded={true} />
      </div>
      {showPopover && (
        <UncontrolledPopover placement="top" trigger="hover click" target={id}>
          <RichTextViewer model={displayName} expanded={true} />
        </UncontrolledPopover>
      )}
      {!hideCount && (
        <div className="text-muted">
          {removed_count
            ? formatMessage(
                {
                  id: 'app.views.engagement_survey.engagement_survey.responses_count_with_removed',
                  defaultMessage:
                    '{count} {count, plural, one {response} other {responses}}. {removed} {removed, plural, one {response} other {responses}} were removed because their grouping was too small to be presented.',
                },
                { count: count ?? 0, removed: removed_count }
              )
            : formatMessage(
                {
                  id: 'app.views.engagement_survey.engagement_survey.responses_count',
                  defaultMessage:
                    '{count} {count, plural, one {response} other {responses}}',
                },
                { count: count ?? 0 }
              )}
        </div>
      )}
    </div>
  );
};

export const truncateString = (string, limit) => {
  // Note that this function may return a string that is 3 characters
  // longer than limit (due to '...')

  if (limit && string?.length > limit) {
    // To ensure we don't truncate the middle of a word
    const latestSpace = string.lastIndexOf(' ', limit);

    return string.slice(0, latestSpace) + '...';
  }
  return string;
};

export const formatFilterList = (
  filterList: string[],
  formatMessage: IntlShape['formatMessage']
): string[] => {
  return (
    filterList
      // sort _others to the end
      .sort((a: string, b: string) => {
        if (a === '_others' && b !== '_others') {
          return 1;
        } else if (a !== '_others' && b === '_others') {
          return -1;
        }
        return a.localeCompare(b);
      })
      // replace _others with readable text
      .map((x) =>
        x === '_others'
          ? formatMessage({
              id: 'app.views.widgets.charts.heatmap.heatmap_row.unspecified_value',
              defaultMessage: 'Not specified',
            })
          : x
      )
  );
};
